import { useState, useCallback } from "react";
import { api } from "../api/client";
import type { User, AuthTokens } from "../types";

export function useAuth() {
  const [user, setUser] = useState<User | null>(() => {
    const stored = localStorage.getItem("user");
    return stored ? (JSON.parse(stored) as User) : null;
  });

  const login = useCallback(async (email: string, password: string) => {
    const data = await api.post<AuthTokens>("/api/auth/login", { email, password });
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);
    localStorage.setItem("user", JSON.stringify(data.user));
    setUser(data.user);
  }, []);

  const register = useCallback(async (email: string, password: string) => {
    const data = await api.post<AuthTokens>("/api/auth/register", { email, password });
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);
    localStorage.setItem("user", JSON.stringify(data.user));
    setUser(data.user);
  }, []);

  const logout = useCallback(async () => {
    const refresh_token = localStorage.getItem("refresh_token");
    if (refresh_token) {
      await api.post("/api/auth/logout", { refresh_token }).catch(() => {});
    }
    localStorage.clear();
    setUser(null);
  }, []);

  return { user, login, register, logout, isAuthenticated: !!user };
}
